import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { PencilIcon } from "lucide-react";
import EmailSettingsForm from "../../modal/my-business/email-setting-form";
import { useState } from "react";
interface EmailSettingsProps {
  setting?: Record<string, string>,
  title: string,
  refetch: () => void
}
export default function EmailSettings({ setting, title, refetch }: EmailSettingsProps) {
  const [isOpen, setOpen] = useState(false);
  const [action, setAction] = useState<"add" | "edit">("add");
  const [data, setData] = useState<Record<string, string> | undefined>(setting);

  const handleEdit = () => {
    setAction("edit");
    setData(setting);
    setOpen(true);
  };

  return (
    <Card className="w-full ">
      <CardHeader className="flex flex-row items-center justify-between px-6 py-2">
        <CardTitle>Email Setting</CardTitle>
        <Button
          size="icon"
          variant="ghost"
          className="rounded-lg bg-primary p-2 shadow-sm hover:bg-primary/90 h-8 w-8"
          onClick={() => handleEdit()}
        >
          <PencilIcon className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <Separator className="h-[1px]" />
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5 mt-2">
          <div className="space-y-1">
            <p className="text-xs ">Gym Email:</p>
            <p className="text-xs text-muted-foreground break-words">
              {setting?.sender_email}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">SMTP Host</p>
            <p className="text-xs text-muted-foreground">
              {setting?.smtp_host}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">SMTP Password:</p>
            <p className="text-xs text-muted-foreground">
              {setting?.smtp_password?.length as number > 0 ? "********" : "No Password"}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">SMTP Port:</p>
            <p className="text-xs text-muted-foreground">
              {setting?.smtp_port}
            </p>
          </div>

          <div className="space-y-1">
            <p className="text-xs ">SMTP Username</p>
            <p className="text-xs text-muted-foreground break-words">
              {setting?.smtp_username}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">CC:</p>
            <p className="text-xs text-muted-foreground break-words">
              {setting?.cc_email}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">BCC:</p>
            <p className="text-xs text-muted-foreground break-words">
              {setting?.bcc_email}
            </p>
          </div>
        </div>
      </CardContent>
      <EmailSettingsForm
        editModeData={data}
        isOpen={isOpen}
        setOpen={setOpen}
        action={action}
        setAction={setAction}
        refetch={refetch}
      />
    </Card>
  );
}
